import React from 'react'
import PopUpContext from './PopUpContext'

export default function usePopUp () {
  const context = React.useContext(PopUpContext)

  if (!context) {
    throw new Error(
      'popUp compound components cannot be rendered outside the popUp component'
    )
  }
  return context
}
